<template>
    <div>
        <keep-alive>
            <component :is="currentPage" />
        </keep-alive>
    </div>
</template>

<script type="module">
export default {
   name: 'BarAndLine',
   components: {
     indicators,
     fgroups,
     hgroups,
     end,
     visualization
   }
}
</script>

<script setup>
import indicators from './bar_and_line/indicators.vue'
import fgroups from './bar_and_line/federal_groups.vue'
import hgroups from './bar_and_line/hospital_groups.vue'
import end from './bar_and_line/end.vue'
import visualization from './bar_and_line/visualization.vue'

import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../stores/vis_store'

const {  loadPages, loadPage, nextPage, previousPage, setUser, setChartType, setYears, setDefaultYear } = useVisualizationsStore()

const {   response, currentPage, pages, loading, arrindicators, user, charttype , defaultyear} = storeToRefs(useVisualizationsStore())
const props = defineProps([  'currentPage', 'user', 'chartType', 'years', 'defaultYear'])
//console.log(props);


loadPages({
     'indicators': indicators,
     'hgroups': hgroups,
     'fgroups': fgroups,
     'end': end,
     'visualization': visualization,
    })



loadPage('indicators');
setUser(props.user);
setChartType(props.chartType);
setYears(props.years);
setDefaultYear(props.defaultYear);


</script>